import React, { Component } from 'react'

// Functions
import { addStyle, removeStyle } from '../../../functions/textEditorFunctions'

// css
import css from '../css/styleSettings.css'



class OverflowSetting extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  change = (e) => {
    let { _this, styleName } = this.props
    const value = e.target.value

    styleName = styleName || 'overflow'

    if (value === '') {
      removeStyle(_this, styleName)
    } else {
      addStyle(_this, {
        style: styleName,
        value
      })
    }
  }

  reset = () => {
    let { _this, styleName } = this.props
    styleName = styleName || 'overflow'

    if (styleName) {
      removeStyle(_this, styleName)
    }
  }

  render() {
    let { _this, styleName } = this.props
    styleName = styleName || 'overflow'
    const overflow = _this.state.style[styleName]

    return (
      <div>
        <table>
          <tbody>
            <tr>
              <td className="pd-0 font-0-7">เนื้อหาล้น (overflow)</td>
              <td className="pd-0 font-0-7 text-right">
                <a className={css.btn} onClick={this.reset}>ค่าเดิม</a>
              </td>
            </tr>
          </tbody>
        </table>

        <div>
          <div className={css.boxInput}>
            <table>
              <tbody>
                <tr>
                  <td width="50%" className="pd-0 font-0-8 center">
                    <select
                      className={`browser-default ${css.input} ${css.select}`}
                      onChange={this.change}
                      value={overflow || ''}>

                      <option value="">ไม่มี</option>
                      <option value="visible">visible</option>
                      <option value="hidden">hidden</option>
                      <option value="scroll">scroll</option>
                      <option value="auto">auto</option>

                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }
}

export default OverflowSetting
